module.exports = __webpack_public_path__ + "img/news1.ac899d53.png";